import axios from 'axios'
import { toast } from 'sonner'

import { apiHost } from '@/lib/host'
import { indexedStorageDB } from '@/lib/local-forage'

axios.defaults.baseURL = apiHost
axios.defaults.withCredentials = true

const axiosInstance = axios.create({
	headers: {
		Accept: 'application/json',
		'Content-Type': 'application/json; charset=UTF-8',
	},
})

let retryAttempt = false

axiosInstance.interceptors.response.use(
	response => response,
	async error => {
		const originalConfig = error.config

		const isAuthLoginFlow =
			originalConfig.url === '/auth/login' ||
			originalConfig.url === '/auth/verify-admin-otp'

		if (!isAuthLoginFlow && error.response) {
			if (error.response.status === 401 && !retryAttempt) {
				retryAttempt = true

				document.cookie = 'accessToken=; Max-Age=0; path=/;'
				document.cookie = 'refreshToken=; Max-Age=0; path=/;'
				indexedStorageDB.clear()
				localStorage.clear()
				const currentPath = window.location.pathname
				if (currentPath !== '/booking-process') {
					toast.error('Session has expired. Please login again')
					window.location.href = '/login'
				}

				try {
					await axiosInstance.post('/auth/refresh-token')
					return axiosInstance(originalConfig)
				} catch (refreshError) {
					document.cookie = 'accessToken=; Max-Age=0; path=/;'
					document.cookie = 'refreshToken=; Max-Age=0; path=/;'
					indexedStorageDB.clear()
					localStorage.clear()
					originalConfig
					const currentPath = window.location.pathname
					if (currentPath !== '/booking-process') {
						toast.error('Session has expired. Please login again')
						window.location.href = '/login'
					}

					return Promise.reject(refreshError)
				}
			}
		}

		return Promise.reject(error)
	},
)

export default axiosInstance
